import React, { useCallback, useEffect, useState } from "react";

import { Button, DateInput, TextInput } from "shared";
import { useCensusContext } from "../../../../Census";
import moment from "moment";

export const CreateCensusForm = ({ onSubmit, onCancel, isBtnLoading }) => {
  const [newCensus, setNewCensus] = useState({
    year: "",
    description: "",
    isActive: false,
    startDate: new Date(),
    endDate: new Date(),
  });
  const [isValid, setIsValid] = useState(false);
  const [isUnique, setIsUnique] = useState(true);
  const { censuses, checkIfActiveCensusExists } = useCensusContext();

  const onInputChange = (event) => {
    const { name: key, value } = event.target;
    setNewCensus((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const onCheckboxChange = (event) => {
    const { checked, name } = event.target;
    setNewCensus((prev) => ({ ...prev, [name]: checked }));
  };

  const onStartDateChange = useCallback((startDate) => {
    setNewCensus((oldState) => ({ ...oldState, startDate }));
  }, []);

  const onEndDateChange = useCallback((endDate) => {
    setNewCensus((oldState) => ({ ...oldState, endDate }));
  }, []);

  useEffect(() => {
    const valid = newCensus.year.toString().length === 4 && newCensus.startDate && newCensus.endDate;
    setIsValid(valid);
    const isUniqueStartDate = (obj) => moment(obj.startDate).isSame(moment(newCensus.startDate), "day");

    const isUniqueYear = (obj) => {
      return obj.year === newCensus.year;
    };
    setIsUnique(!censuses.some(isUniqueYear) && !censuses.some(isUniqueStartDate));
  }, [newCensus, censuses]);

  const confirm = () => {
    if (!isValid) return alert("Popunite sva ponuđena polja, vrednost za polje 'Godina' mora imati 4 cifre.");
    if (!isUnique) return alert("Početni datum popisa i godina popisa moraju biti jedinstveni.");
    onSubmit(newCensus);
  };

  return (
    <>
      <div className="create-company">
        <h2 className="create-company__title">Kreiranje novog popisa</h2>
        <label className="create-small-inventory-value__label">Početak popisa</label>
        <DateInput onChange={onStartDateChange} selected={newCensus.startDate} />
        <label className="create-small-inventory-value__label">Kraj popisa</label>
        <DateInput onChange={onEndDateChange} selected={newCensus.endDate} />
        <TextInput
          name="year"
          onChange={onInputChange}
          autoComplete="off"
          placeholder="Godina popisa"
          value={newCensus.year || ""}
          maxLength={4}
          type="number"
        />
        <TextInput
          name="description"
          onChange={onInputChange}
          autoComplete="off"
          value={newCensus.description || ""}
          placeholder="Opis"
        />
        <TextInput
          disabled={checkIfActiveCensusExists()}
          name="isActive"
          type="checkbox"
          onChange={onCheckboxChange}
          value={newCensus.isActive}
          label="Aktivan popis"
        />
      </div>
      <div className="create-company__controls">
        <Button
          buttonText={"Potvrdi"}
          buttonColor={"red"}
          event={confirm}
          spinnerColor={"light"}
          isLoading={isBtnLoading}
        />
        <Button buttonText={"Otkaži"} buttonColor={"gray"} event={onCancel} />
      </div>
    </>
  );
};
